import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '产品介绍'
          },
          children: [
            {
              path: '/software',
              redirect: '/software/smartTown'
            },
            {
              path: '/software/smartTown',
              name: 'software',
              component: resolve => require(['@/view/Software_smartTown'], resolve),
              meta: {
                title: '产品介绍丨云HIS'
              }
            },
            {
              path: '/software/bigData',
              name: 'software',
              component: resolve => require(['@/view/Software_bigData'], resolve),
              meta: {
                title: '产品介绍丨互联网诊疗'
              }
            },
            {
                path: '/software/yiTiHuaPingTai',
                name: 'software',
                component: resolve => require(['@/view/Software_yiTiHuaPingTai'], resolve),
                meta: {
                  title: '产品介绍丨基层一体化平台'
                }
              },
              {
                path: '/software/LIS',
                name: 'software',
                component: resolve => require(['@/view/Software_lis'], resolve),
                meta: {
                  title: '产品介绍丨LIS & PACS'
                }
              },
              {
                path: '/software/Yingjian',
                name: 'software',
                component: resolve => require(['@/view/Software_yingjian'], resolve),
                meta: {
                  title: '产品介绍丨硬件设备'
                }
              },
              {
                path: '/software/Tijianxitong',
                name: 'software',
                component: resolve => require(['@/view/Software_tijianxitong'], resolve),
                meta: {
                  title: '产品介绍丨体检系统'
                }
              }
          ]
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/ServiceDetail'], resolve),
          meta: {
            title: '项目案例'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '申请试用'
          }
        }, /* {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会'
          }
        }, */ {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '相关服务'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: '相关服务'
          }
        }
        /*,
        {
            path: '/login',
            name: 'login',
            component: resolve => require(['@/view/Login'], resolve),
            meta: {
              title: '登录系统'
            }
          }*/
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js